<div class="flex flex-col gap-6">
  <p class="m-0 text-base">
    {{ description }}
  </p>
  <div>
    <span>{{ 'Not sure what to enter?' | translate }}</span>
    <p class="m-0 pt-0 text-sm font-thin text-support italic">
      {{ explanation }}
    </p>
  </div>

  <sb-form-field [errorWhen]="['touched']" [control]="control" [label]="fieldLabel">
    <div class="flex flex-row">
      @if (prefix === 'currency') {
        <div class="input-affix">{{ '' | currencySymbol }}</div>
      }
      @if (prefix === 'percentage') {
        <div class="input-affix">
          <sb-icon size="sm" [name]="'percentage'" />
        </div>
      }
      <decimal-input
        [fullWidth]="true"
        class="w-full"
        [decimals]="2"
        [min]="0"
        [placeholder]="placeholder"
        [defaultValue]="''"
        [formControl]="control"
        [step]="0.01"
      ></decimal-input>
    </div>
  </sb-form-field>
</div>
